import { render, staticRenderFns } from "./wageInfo.vue?vue&type=template&id=3f907ce6&scoped=true&"
import script from "./wageInfo.vue?vue&type=script&lang=js&"
export * from "./wageInfo.vue?vue&type=script&lang=js&"
import style0 from "./wageInfo.vue?vue&type=style&index=0&id=3f907ce6&scoped=true&lang=css&"
import style1 from "./wageInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f907ce6",
  null
  
)

export default component.exports